import ReferrerProvider from "./ReferrerProvider";

export default ReferrerProvider;
